<section class="hero">
    <div class="hero-content">
        <ngb-carousel class="carousel-fade no-indicators" [showNavigationArrows]="false"
            style="max-width: 300px; border-color: white; border-style: solid; border-width: 4px; margin-left: auto; margin-right: auto;">
            <ng-template ngbSlide>

                <img src="assets/slide1.png" class="d-block w-100" alt="slide.Alt" />
                <div class="carousel-caption d-none">
                </div>
            </ng-template>
            <ng-template ngbSlide>

                <img src="assets/slide2.png" class="d-block w-100" alt="slide.Alt" />
                <div class="carousel-caption d-none ">
                </div>
            </ng-template>
            <ng-template ngbSlide>

                <img src="assets/slide3.png" class="d-block w-100" alt="slide.Alt" />
                <div class="carousel-caption d-none">
                </div>
            </ng-template>
            <ng-template ngbSlide>

                <img src="assets/slide4.png" class="d-block w-100" alt="slide.Alt" />
                <div class="carousel-caption d-none">
                </div>
            </ng-template>
        </ngb-carousel>
        <h1>Modern fototävlingsplattform</h1>
        <p class="hero-tagline">Enkel uppladdning • Intuitiv röstning • Professionellt resultat • Bildanalys</p>
        <a href="#features" class="cta-button">Upptäck funktioner</a>
        <a href="#how-it-works" class="cta-button secondary">Så fungerar det</a>
    </div>
</section>

<!-- Features Section -->
<section class="features" id="features">
    <h2 class="section-title">Varför välja vår plattform?</h2>
    <div class="features-grid">
        <div class="feature-card">
            <span class="feature-icon">⚡</span>
            <h3>Blixtsnabb uppladdning</h3>
            <p>Dra och släpp dina bilder eller klicka för att välja. Systemet skalar automatiskt bilderna till optimal
                storlek för alla enheter.</p>
        </div>

        <div class="feature-card">
            <span class="feature-icon">🎯</span>
            <h3>Intuitiv dra-och-släpp röstning</h3>
            <p>Inga krångliga formulär! Dra bilderna till rätt position och få omedelbar översikt över din rangordning.
                Enkelt och tydligt.</p>
        </div>

        <div class="feature-card">
            <span class="feature-icon">🔍</span>
            <h3>Jämför bilder sida vid sida</h3>
            <p>Svårt att välja? Använd vår jämförelsefunktion för att se bilder bredvid varandra med zoom-funktion för
                att studera detaljerna.</p>
        </div>

        <div class="feature-card">
            <span class="feature-icon">📱</span>
            <h3>Fungerar överallt</h3>
            <p>Perfekt optimerad för dator, surfplatta och mobil. Samma smidiga upplevelse oavsett vilken enhet du
                använder.</p>
        </div>

        <div class="feature-card">
            <span class="feature-icon">✏️</span>
            <h3>Flexibel redigering</h3>
            <p>Ändra din röstning eller dina bidrag så många gånger du vill fram till tävlingens sista dag. Full
                kontroll!</p>
        </div>

        <div class="feature-card">
            <span class="feature-icon">📄</span>
            <h3>Professionellt resultat</h3>
            <p>När tävlingen är över genereras automatiskt en snygg PDF med alla bilder, kommentarer och resultat.</p>
        </div>
    </div>
</section>

<section class="how-it-works" id="how-it-works">
    <h2 class="section-title">Anordna en fototävling</h2>
    <div class="steps">
        <div class="step">
            <div class="step-number">1</div>
            <div class="step-content">
                <h3>Kontakta oss</h3>
                <p>Tag kontakt med oss så skapar vi en tävling/bildanalys</p>
            </div>
        </div>
        
        <div class="step">
            <div class="step-number">2</div>
            <div class="step-content">
                <h3>Vi skapar tävlingen</h3>
                <p>Vi skapar upp tävlingen</p>
            </div>
        </div>
        
        <div class="step">
            <div class="step-number">3</div>
            <div class="step-content">
                <h3>Vi skickar länkar</h3>
                <p>Vi skickar en epost med länkar till att kunna registrera sig för att lägga till bilder och/eller rösta</p>
            </div>
        </div>
        
    </div>
</section>
<hr>
<!-- How It Works Section -->
<section class="how-it-works" id="how-it-works">
    <h2 class="section-title">Så fungerar det att delta eller rösta</h2>
    <div class="steps">
        <div class="step">
            <div class="step-number">1</div>
            <div class="step-content">
                <h3>Få din inbjudan</h3>
                <p>Arrangören skickar en unik länk via e-post. Klicka på länken för att komma till tävlingssidan.</p>
            </div>
        </div>

        <div class="step">
            <div class="step-number">2</div>
            <div class="step-content">
                <h3>Registrera dig eller logga in</h3>
                <p>Skapa ett konto med e-post och lösenord, alternativt använd Facebook eller Google för att snabbt logga in eller skapa ett konto.</p>
            </div>
        </div>

        <div class="step">
            <div class="step-number">3</div>
            <div class="step-content">
                <h3>Ladda upp dina bilder</h3>
                <p>Dra och släpp dina JPEG-bilder, lägg till titel och beskrivning. Systemet skalar automatiskt
                    bilderna.</p>
            </div>
        </div>

        <div class="step">
            <div class="step-number">4</div>
            <div class="step-content">
                <h3>Rösta på andras bilder</h3>
                <p>Dra bilderna i den ordning du tycker är bäst. Använd jämförelsefunktionen om du är osäker. Om det inte är en tävling utan bara bildanalys så kan du inte dra bilderna i en annan ordning.</p>
            </div>
        </div>

        <div class="step">
            <div class="step-number">5</div>
            <div class="step-content">
                <h3>Skriv kommentarer</h3>
                <p>Analysera och kommentera bilder kan göras både vid tävling och när plattformen endast används för bildanalys.</p>
            </div>
        </div>

        <div class="step">
            <div class="step-number">6</div>
            <div class="step-content">
                <h3>Se resultatet</h3>
                <p>När tävlingen är avslutad får du en professionell PDF med alla bilder, kommentarer och slutresultat.
                </p>
            </div>
        </div>
    </div>
</section>

<!-- Benefits Section -->
<section class="benefits">
    <h2 class="section-title">Fördelar som gör skillnad</h2>
    <div class="benefits-grid">
        <div class="benefit-item">
            <span class="icon">⚡</span>
            <h4>Snabbt & Smidigt</h4>
            <p>Ingen inlärningskurva – alla förstår direkt</p>
        </div>

        <div class="benefit-item">
            <span class="icon">🔒</span>
            <h4>Säker inloggning</h4>
            <p>E-post/lösenord eller Facebook</p>
        </div>

        <div class="benefit-item">
            <span class="icon">👁️</span>
            <h4>Anonym röstning</h4>
            <p>Rättvist utan påverkan</p>
        </div>

        <div class="benefit-item">
            <span class="icon">💬</span>
            <h4>Konstruktiv feedback</h4>
            <p>Ge uppmuntrande kommentarer</p>
        </div>

        <div class="benefit-item">
            <span class="icon">🎨</span>
            <h4>Automatisk bildhantering</h4>
            <p>Vi optimerar bilderna åt dig</p>
        </div>

        <div class="benefit-item">
            <span class="icon">🏆</span>
            <h4>Professionell PDF</h4>
            <p>Snyggt slutresultat att dela</p>
        </div>
    </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
    <h2>Redo att skapa en minnesvärd fototävling?</h2>
    <p>Perfekt för företag, föreningar, familjer och grupper av alla storlekar</p>
    <a href="https://foto.erikslada.se" class="cta-button">Kontakta oss om en tävling/bildanalys</a>
</section>